<template>
  <div v-show="show" :transition="transition" v-esc="escape">
    <div class="modal" @click.self="clickMask">
      <div class="modal-dialog" :class="{'modal-sm': small, 'modal-lg': large, 'modal-full': full, 'modal-auto-height': autoHeight}">
        <div class="modal-content">
          <!--Header-->
          <div class="modal-header">
            <slot name="header">
              <a type="button" class="close" @click="cancel">x</a>
              <h4 class="modal-title">
                <slot name="title"><span v-html="title"></span></slot>
              </h4>
            </slot>
          </div>
          <!--Container-->
          <div class="modal-body" :style="bodyStyle">
            <slot></slot>
            <div class="clearfix"></div>
          </div>
          <!--Footer-->
          <div v-if="footer === 'default'" class="modal-footer text-left">
            <slot name="footer">
              <button type="button" :class="cancelClass" @click="cancel" v-html="cancelText" class="pull-right"></button>
              <i class="fa fa-fw fa-lg fa-spin fa-spinner" v-if="loading"></i>
              <button type="button" :class="okClass" @click="ok" :disabled="loading || okDisabled" v-html="okText" class="bold"></button>
            </slot>
          </div>
          <div v-if="footer === 'custom'" class="modal-footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop in"></div>
  </div>
</template>

<script>
  export default {
    name: 'ModalBootstrap',
    props: {
      show: {
        type: Boolean,
        twoWay: true,
        default: false
      },
      bodyStyle: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: 'Modal'
      },
      focus: {
        type: String,
        default: ''
      },
      small: {
        type: Boolean,
        default: false
      },
      large: {
        type: Boolean,
        default: false
      },
      autoHeight: {
        type: Boolean,
        default: false
      },
      full: {
        type: Boolean,
        default: false
      },
      force: {
        type: Boolean,
        default: false
      },
      footer: {
        type: String,
        default: 'default'
      },
      transition: {
        type: String,
        default: 'modal'
      },
      loading: {
        type: Boolean,
        default: false
      },
      okText: {
        type: String,
        default: 'OK'
      },
      okDisabled: {
        type: Boolean,
        default: false
      },
      cancelText: {
        type: String,
        default: 'Cancelar'
      },
      okClass: {
        type: String,
        default: 'btn btn-info'
      },
      cancelClass: {
        type: String,
        default: 'btn btn-default'
      },
      closeWhenOK: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        style: '',
        duration: null,
        modalHeight: document.body.scrollHeight
      }
    },
    computed: {
      modalClass () {
        return {
          'modal-lg': this.large,
          'modal-sm': this.small,
          'modal-full': this.full
        }
      }
    },
    created () {
      if (this.show) {
        window.$('body').addClass('modal-open')
      }
      window.addEventListener('resize', this.height)
      this.height()
    },
    watch: {
      'show' (to, from) {
        if (to && this.focus !== '') {
          setTimeout(() => {
            window.$('[name=' + this.focus + ']', this.$el).focus()
          }, 0)
        }
      }
    },
    beforeDestroy () {
      document.body.className = document.body.className.replace(/\s?modal-open/, '')
    },
    destroyed () {
      window.removeEventListener('resize', this.height)
    },
    methods: {
      height () {
        let total = document.documentElement.clientHeight
        let max = total - 300
        max += 'px'
        if (!this.autoHeight) {
          this.style = 'height: ' + max + ';'
        } else {
          this.style = 'height: auto; max-height: ' + max + ';'
        }
      },
      ok () {
        this.$emit('close', {action: 'ok'})
      },
      cancel () {
        this.$emit('close', {action: 'cancel'})
      },
      clickMask () {
        if (!this.force) {
          this.cancel()
        }
      },
      escape (event) {
        if (!this.force) {
          this.cancel()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ModalBootstrap.vue?74768454